import {
  BulkCommunicationCreateData,
  CommunicationDelivery,
  CommunicationSearchItem,
} from "@/types/communication";
import { adminUrl } from "@/utils/url";
import { HttpClient } from "../HttpClient";
import { toServiceError } from "../errors";
import { ICommunicationManagementService } from "./ICommunicationManagementService";

/**
 * A bulk create validates the filters and counts the clients before it
 * answers, so it gets more room than a plain read.
 */
const BULK_TIMEOUT_MS = 30000;

export class CommunicationManagementService implements ICommunicationManagementService {
  private httpClient: HttpClient;

  constructor() {
    this.httpClient = new HttpClient({
      baseURL: `${adminUrl}/communications`,
      timeout: 10000,
      headers: {},
    });
  }

  async createBulk(
    data: BulkCommunicationCreateData,
  ): Promise<CommunicationSearchItem> {
    try {
      return await this.httpClient.post<CommunicationSearchItem>(
        `/bulk`,
        data,
        { timeout: BULK_TIMEOUT_MS },
      );
    } catch (error) {
      throw toServiceError(
        error,
        "Não foi possível enviar a comunicação. Reveja os filtros e o conteúdo e tente novamente.",
      );
    }
  }

  async resend(
    communicationId: number,
    includeSkipped = false,
  ): Promise<CommunicationSearchItem> {
    const query = includeSkipped ? "?includeSkippedDeliveries=true" : "";

    try {
      return await this.httpClient.post<CommunicationSearchItem>(
        `/${communicationId}/resend${query}`,
      );
    } catch (error) {
      throw toServiceError(
        error,
        "Não foi possível reenviar a comunicação. Tente novamente.",
      );
    }
  }

  async resendToClient(
    communicationId: number,
    clientId: number,
  ): Promise<CommunicationDelivery> {
    try {
      return await this.httpClient.post<CommunicationDelivery>(
        `/${communicationId}/delivery/resend-to/${clientId}`,
      );
    } catch (error) {
      throw toServiceError(
        error,
        "Não foi possível reenviar a comunicação a este cliente. Tente novamente.",
      );
    }
  }

  async cancel(communicationId: number): Promise<void> {
    try {
      await this.httpClient.patch<void>(`/${communicationId}/cancel`);
    } catch (error) {
      throw toServiceError(
        error,
        "Não foi possível cancelar a comunicação. Tente novamente.",
      );
    }
  }

  async cancelDelivery(deliveryId: number): Promise<void> {
    try {
      await this.httpClient.patch<void>(`/delivery/${deliveryId}/cancel`);
    } catch (error) {
      throw toServiceError(
        error,
        "Não foi possível cancelar esta entrega. Tente novamente.",
      );
    }
  }
}
